export default __webpack_public_path__ + "static/IP_Vision_Pro_10-13f0c238f8753cc797416bc558bb9bad.webp";